
















































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import { PersonModule } from '@/store/Customers/PersonModule';
import DepositAccount from '@/models/Accounts/DepositAccounts/DepositAccount';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import CreateCardRequest from '@/models/Accounts/Shared/Cards/CreateCardRequest';
import ProductType from "@/models/Products/ProductType";
import PermissionUtils from '@/lib/permissionUtils';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'CardCreate' })
export default class extends SaascadaVueDialog {

    dialog = false;
    request: CreateCardRequest = new CreateCardRequest();

    @Prop({required: true})
    account: DepositAccount;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateCardRequest();
            // Reset the search value for getting a person
            this.search = '';
        }
    }

    get hasUXApiAccess() {
        return AuthModule.me.institution.config.uxApiAccess && PermissionUtils.allowUxApiAccess();
    }

    get search() {
        return PersonModule.peopleSearch;
    }

    set search(searchText: string) {
        PersonModule.updatePeopleSearch(searchText);
    }

    get personOptions() {
        return PersonModule.people;
    }

    get cardProcessorOptions() {
        return AuthModule.me.institution.config.cardIntegrations;
    }

    get loadingPeople() {
        return PersonModule.loading;
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Passing null for the page number parameter to get as many results as possible
        await PersonModule.getPeople(null);
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // If not using UX then set the account number in the request
            // or if wallet is not provided then also revert to using account ID instead
            if (!this.hasUXApiAccess || !this.request.walletId) {
                this.request.accountId = this.account.id;
            }

            if (this.account.productType === ProductType.Deposit) {
                await DepositAccountModule.createCard(this.request);
                await DepositAccountModule.getCards(1);
            }
        }
    }

}
